import gql from "graphql-tag";

export default gql`
  query {
    userIDs(last: 1) {
      userID
    }
  }
`;
